import { paginationOptions, navigationOptions } from "Config/slider/default"
import { productsSliderOptions, similarProductsSliderOptions, compactProductsSliderOptions, combidealProductsSliderOptions, dashboardProductsSliderOptions, endedProductsSliderOptions, articleProductsSliderOptions } from "Config/slider/product"
import { bannerSliderOptions } from "Config/slider/banner"
import { branchGallerySliderOptions } from "Config/slider/branch"
import { testimonialsSliderOptions } from "Config/slider/testimonial"
import { productBlockImagesSliderOptions } from "Config/slider/product-block-images"

import { rSwiperVisibleItems } from 'Functions/swiper-visible-items'
import { rSwiperCssNavFix } from 'Functions/swiper-css-nav-fix'
import { Pagination, Navigation, Autoplay  } from 'swiper';
import { b2bLandingAmbassadorsSliderOptions } from "./b2b-landing"

export const sliderOptions = instance => {
    // default options
    let options = {
        simulateTouch: false,
        watchOverflow: true,
        preventInteractionOnTransition: true,
        roundLengths: true,
        modules: [Pagination, Navigation, Autoplay, rSwiperVisibleItems, rSwiperCssNavFix]
    }

    if (instance.paginationEl) {
        options = {...options, ...paginationOptions(instance)}
    }

    if (instance.prevEl && instance.nextEl) {
        options = {...options, ...navigationOptions(instance)}
    }

    if (instance.hasAttribute('r-banner-slider')) {
        options = {...options, ...bannerSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-branch-gallery')) {
        options = {...options, ...branchGallerySliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-products')) {
        options = {...options, ...productsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-compact-products')) {
        options = {...options, ...compactProductsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-combideal-products')) {
        options = {...options, ...combidealProductsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-similar-products')) {
        options = {...options, ...similarProductsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-dashboard-products')) {
        options = {...options, ...dashboardProductsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-ended-products')) {
        options = {...options, ...endedProductsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-b2b-landing-ambassadors')) {
        options = {...options, ...b2bLandingAmbassadorsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-testimonials')) {
        options = {...options, ...testimonialsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-article-products-slider')) {
        const maxVisibleItems = instance.hasAttribute('r-max-visible-items') ? instance.getAttribute('r-max-visible-items') : 4
        options = {...options, ...articleProductsSliderOptions(instance, options, maxVisibleItems)}
    }

    if (instance.hasAttribute('r-slider-product-block-images')) {
        options = {...options, ...productBlockImagesSliderOptions(instance, options)}
    }

    return {...options, ...instance.customOptions}
}